export function isKlarnaAvailable(acceptedPaymentMethods: string[]) {
  if (!acceptedPaymentMethods) { return false; }

  return acceptedPaymentMethods.includes('klarna_account');
}

export function filterBuyerPaymentMethods(acceptedPaymentMethods?: string[]) {
  if (!acceptedPaymentMethods) { return []; }
  return acceptedPaymentMethods;
}
